import script from "./ResultMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ResultMessage.vue?vue&type=style&index=0&id=484f69f2&lang=css"

const __exports__ = script;

export default __exports__